"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventToTable = EventToTable;
exports.EventToTableB = EventToTableB;
var common_1 = require("./common");
var sprintf_js_1 = require("sprintf-js");
var time_1 = require("@ca/time");
var crypto_1 = require("@ca/crypto");
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
var response_1 = require("@ca/wrap-sdk/src/response");
var common_2 = require("./common");
function EventToTable(creds, event) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (common_1.EVENT_BUS_TABLE === "") {
                        if (common_2.DEBUG) {
                            console.log("EventToTable no event bus defined");
                        }
                        // No event bus defined.
                        return [2 /*return*/, (0, response_1.SuccessResponse)({ msg: "No event bus defined" })];
                    }
                    return [4 /*yield*/, EventToTableB(creds, common_1.EVENT_BUS_TABLE, event)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function EventToTableB(creds, event_table, event) {
    return __awaiter(this, void 0, void 0, function () {
        var time_ms, item, index, username, resp;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    time_ms = (0, time_1.get_now_ms)();
                    item = (_a = {
                            partition: common_1.PARTITION,
                            id: (0, sprintf_js_1.sprintf)("%d", time_ms) + "-" + (0, crypto_1.rnd_string)(10),
                            time: event.time
                        },
                        _a['detail-type'] = event['detail-type'],
                        _a.event = event,
                        _a);
                    index = null;
                    username = null;
                    if (event.detail && 'index' in event.detail) {
                        index = parseInt(event.detail.index, 10);
                    }
                    if (event.detail && event.detail.username) {
                        username = event.detail.username;
                    }
                    if (index !== null && username !== null) {
                        item.username_index = (0, sprintf_js_1.sprintf)("%s_%04d", username, index);
                    }
                    else if (username !== null) {
                        item.username_index = username;
                    }
                    if (event.detail && 'account_number' in event.detail) {
                        item.account_number = event.detail.account_number;
                    }
                    if (common_2.DEBUG) {
                        console.log("EventToTableB posting to", event_table, item);
                    }
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchWriteC)(creds, (_b = {}, _b[event_table] = [item], _b))];
                case 1:
                    resp = _c.sent();
                    if (resp.status !== response_1.Status.OK) {
                        console.log(resp);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)(item)];
            }
        });
    });
}
//# sourceMappingURL=dispatch.js.map